import gql from 'graphql-tag';

export const UPDATE_BRIEF_FISCAL_PERIOD = gql`
  mutation UpdateBriefsFiscalPeriodMutation($data: BulkBriefFiscalPeriodLinkInput!) {
    linkBriefsWithFiscalPeriods(data: $data)
  }
`;
